export enum DragType {
  TEMPLATE = 'TEMPLATE',
  MODULE = 'MODULE',
  TAB = 'TAB',
  ANNOTATIONS_MARKER = 'ANNOTATIONS_MARKER',
}

export type DragItem = {
  entityType?: string;
  index?: number;
  id?: string;
};
